<template>
  <li
    :class="liClass"
    @click="$emit('openConversation', item)"
  >
    <div
      :id="id"
      :aria-controls="ariaControls"
      :aria-selected="ariaSelected"
      :class="'nav-link '+className"
      :data-toggle="dataToggle"
      class="rounded-10 d-flex w-100"
    >
      <slot
        v-if="hasTitleSlot"
        name="title"
      />
      <template v-else>
        {{ title }}
      </template>
    </div>
  </li>
</template>
<script>
export default {
  name: 'TabNavItems',
  props: {
    id: { type: String || Number, default: 'myTab' },
    active: { type: Boolean, default: false },
    role: { type: String, default: 'tab' },
    ariaControls: { type: String, default: 'tabpanel' },
    ariaSelected: { type: Boolean, default: false },
    dataToggle: { type: String, default: 'tab' },
    href: { type: String, default: '' },
    title: { type: String, default: '' },
    liClass: { type: String, default: 'nav-item' },
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      className: ''
    }
  },
  computed: {
    hasTitleSlot () {
      return !!this.$slots.title
    },
    url () {
      if (this.href === '') {
        return `#${this.ariaControls}`
      }
      return this.href
    }
  },
  mounted () {
    if (this.active) {
      this.className = 'show active'
    }
  }
}
</script>
